<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">
                        <!-- Dashboard Box -->

                        <div class="col-lg-8 col-md-7 col-xs-12 col-xl-5">
                            <div class="tabs tabs-default margin-top-0 margin-bottom-15">
                                <div class="tabs-header">
                                    <ul style="width: 100%;">
                                        <li style="width: 25%;" v-bind:class="{'active': tab == 'lista'}">
                                            <a v-on:click="setTab('lista')">
                                                <i class="material-icons">menu</i>
                                                Lista
                                            </a>
                                        </li>
                                        <li style="width: 25%;" v-bind:class="{'active': tab == 'visualizar'}">
                                            <a v-on:click="setTab('visualizar')">
                                                <i class="material-icons">insert_chart</i>
                                                Gráficos
                                            </a>
                                        </li>
                                        <li style="width: 25%;" v-bind:class="{'active': tab == 'editar'}">
                                            <a v-on:click="setTab('editar')">
                                                <i class="material-icons">edit</i>
                                                Editar
                                            </a>
                                        </li>
                                        <li style="width: 25%;" v-bind:class="{'active': tab == 'historico'}">
                                            <a v-on:click="setTab('historico')">
                                                <i class="material-icons">access_time</i>
                                                Histórico
                                            </a>
                                        </li>                                        
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-12 tab-visualizar" v-show="tab == 'lista'">
                        
                            <div class="margin-top-20" v-for="(item, index) in Object.keys(data.itens)">
                                <h3 class="margin-bottom-10">
                                    <i class="material-icons">store</i>
                                    <b>{{item}}</b>
                                </h3>
                                <div style="padding: 10px">
                                    <div class="row" style="border: 1px solid #ddd; background: #fff;">
                                        <div class="col-xl-4 col-md-6 col-lg-6 col-xs-12 tanque" v-for="(item2, index) in data.itens[item]">
                                            <h4>
                                                <i class="material-icons">local_gas_station</i>
                                                <b>{{item2.nome}}</b>
                                                <br>
                                                <router-link :to="{'name': 'MovimentarEstoque', 'query': {'c': item2.cod}}" class="dashboard-status-button color-green">
                                                    <i class="material-icons">redo</i>
                                                    Movimentar
                                                </router-link>                                                
                                            </h4>
                                            <p>
                                                Estoque atual: <b>{{parseFloat(item2.quantidade).toLocaleString("pt-br", {minimumFractionDigits: 1})}}L</b> (<b>{{item2.porcentagem}}%</b>)
                                            </p>
                                            <p>
                                                Volume livre: <b>{{parseFloat(item2.livre).toLocaleString("pt-br", {minimumFractionDigits: 1})}}L</b>
                                            </p>                                        
                                            <p>
                                                Capacidade: <b>{{parseFloat(item2.capacidade).toLocaleString("pt-br", {minimumFractionDigits: 1})}}L</b>
                                            </p> 
                                            <p style="font-size: 12px;">
                                                Atualização: <b>{{item2.atualizacao |formatDate}}</b>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>  


                        <div class="col-xl-12 tab-visualizar" v-show="tab == 'visualizar'">
                        
                            <div class="margin-top-20" v-for="(item, index) in Object.keys(data.itens)">
                                <h3 class="margin-bottom-10">
                                    <i class="material-icons">store</i>
                                    <b>{{item}}</b>
                                </h3>
                                <div style="padding: 10px">
                                    <div class="row" style="border: 1px solid #ddd; background: #fff;">
                                        <div class="col-xl-4 col-md-6 col-lg-6 col-xs-12 tanque" v-for="(item2, index) in data.itens[item]">
                                            <h4>
                                                <i class="material-icons">local_gas_station</i>
                                                <b>{{item2.nome}}</b>
                                                <br>
                                                <router-link :to="{'name': 'MovimentarEstoque', 'query': {'c': item2.cod}}" class="dashboard-status-button color-green">
                                                    <i class="material-icons">redo</i>
                                                    Movimentar
                                                </router-link>                                                
                                            </h4>
                                            <div v-bind:class="'tanque-conteudo-' + item2.cod"></div>   
                                            <p>
                                                Estoque atual: <b>{{parseFloat(item2.quantidade).toLocaleString("pt-br", {minimumFractionDigits: 1})}}L</b> (<b>{{item2.porcentagem}}%</b>)
                                            </p>
                                            <p>
                                                Volume livre: <b>{{parseFloat(item2.livre).toLocaleString("pt-br", {minimumFractionDigits: 1})}}L</b>
                                            </p>                                        
                                            <p>
                                                Capacidade: <b>{{parseFloat(item2.capacidade).toLocaleString("pt-br", {minimumFractionDigits: 1})}}L</b>
                                            </p>    
                                            <p style="font-size: 12px;">
                                                Atualização: <b>{{item2.atualizacao |formatDate}}</b>
                                            </p>                                                                                
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>  

                        <div class="col-xl-12 tab-editar" v-show="tab == 'editar'">

                            <router-link v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'" :to="{'name': 'CadastrarEstoque'}" class="button block-mobile margin-top-10">
                                <i class="material-icons">add</i>
                                Cadastrar <b>tanque fixo</b> ou <b>CTA</b>
                            </router-link>


                            <div class="table-scroll margin-top-20" style="overflow-x: scroll;">

                                <div v-for="(item, index) in Object.keys(data.itens)">
                                    <h4 class="margin-bottom-10">
                                        <i class="material-icons">store</i>
                                        <b>{{item}}</b>
                                    </h4>

                                    <table class="table table-bordered table-bordered-default table-responsive margin-bottom-20">
                                        <thead>
                                            <th style="min-width: 10px; width: 30px;">
                                                ID
                                            </th>
                                            <th style="min-width: 180px;">
                                                Nome
                                            </th>
                                            <th style="min-width: 80px; width: 80px;">
                                                Produto
                                            </th>                                        
                                            <th style="min-width: 100px; width: 100px;">
                                                Capacidade
                                            </th>
                                            <th style="min-width: 130px; width: 130px;">
                                                Estoque atual
                                            </th>
                                            <th style="min-width: 100px; width: 100px;">
                                                Volume livre
                                            </th>                                            
                                            <th style="min-width: 140px; width: 140px;">
                                                Atualização
                                            </th>   
                                            <th style="min-width: 132px; width: 132px;">
                                                Ações
                                            </th>                                                                      
                                        </thead>
                                        <tbody>


                                            <tr v-show="data.itens[item].length == 0 && loaded">
                                                <td data-label="" colspan="7">
                                                    Nenhum resultado encontrado.
                                                </td>                                                                                           
                                            </tr>
                                           
                                            <tr v-for="(item2, index) in data.itens[item]">
                                                <td data-label="ID">
                                                    {{item2.id}}                                  
                                                </td>
                                                <td data-label="Nome" style="">
                                                    {{item2.nome}}
                                                    <br>
                                                    <small>
                                                        <i class="material-icons">info</i> Número: <strong style="font-weight: bold !important; color: #000;">{{parseFloat(item2.numero).toFixed(1).toLocaleString("pt-br", {minimumFractionDigits: 1})}}</strong>
                                                    </small>
                                                    <br>
                                                    <small>
                                                        <i class="material-icons">info</i> Medição: <strong style="font-weight: bold !important; color: #000;">{{item2.medicao}}</strong>
                                                    </small>     

                                                    <br v-if="item2.medicoes.length > 0">

                                                    <ul v-if="item2.medicoes.length > 0" style="margin-top: 10px; margin-bottom: 0px">
                                                        <li v-for="(item3, index) in item2.medicoes" style="font-size: 12px; padding-bottom: 10px;">
                                                            <i class="material-icons">event</i> Medição realizada em {{item3.datahora | formatDate}} = <strong style="color: #000">{{item3.medicao}}cm</strong>
                                                            <br>
                                                             <i class="material-icons">photo</i> <a style="text-decoration: underline;" target="_blank" :href="item3.arquivo">Visualizar foto</a>
                                                        </li>                
                                                    </ul>

                                                </td>     
                                                <td data-label="Produto" style="">
                                                    {{item2.catalogo.nome}}
                                                </td>                                                                                            
                                                <td data-label="Capacidade">
                                                    {{parseFloat(item2.capacidade).toLocaleString("pt-br", {minimumFractionDigits: 1})}}L
                                                </td>
                                                <td data-label="Estoque atual" style="">
                                                    {{parseFloat(item2.quantidade).toLocaleString("pt-br", {minimumFractionDigits: 1})}}L ({{item2.porcentagem}}%)
                                                    <router-link :to="{'name': 'MovimentarEstoque', 'query': {'c': item2.cod}}" class="dashboard-status-button color-green">
                                                        <i class="material-icons">redo</i>
                                                        Movimentar
                                                    </router-link>
                                                </td>
                                                <td data-label="Volume livre" style="">
                                                    {{(item2.capacidade - item2.quantidade).toLocaleString("pt-br", {minimumFractionDigits: 1})}}L
                                                </td>                                                        
                                                <td data-label="Última atualização" style="">
                                                    {{item2.atualizacao |formatDate}}
                                                </td>                                                                 
                                                <td data-label="Ações">
                                                    <router-link v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'" :to="{'name': 'EditarEstoque', 'query': {'c': item2.cod}}" class="dashboard-status-button gray">Editar</router-link>
                                                    <a  v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'" v-on:click="del(item2.cod)" class="dashboard-status-button color-red">Apagar</a>                                                   
                                                </td>                                                                                             
                                            </tr>
                                                                                 
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>

                        <div class="col-xl-12 tab-historico" v-show="tab == 'historico'">


                            <form method="getHistorico" style="width: 100%;" class="margin-bottom-0 margin-top-10" v-on:submit.prevent="form.page = 1;get(true);" novalidate="">
                                <div class="row">

                                    <div class="col-lg-4 col-xs-6 col-xl-3 col-md-5">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>De:</h5>
                                            <input type="date" data-placeholder="___ /____ /_____" required="" class="with-border margin-bottom-0" v-model="formHistorico.dataInicio">
                                        </div>
                                    </div>        
                                    <div class="col-lg-4 col-xs-6 col-xl-3 col-md-5">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Até:</h5>
                                            <input type="date" data-placeholder="___ /____ /_____" required="" class="with-border margin-bottom-0" v-model="formHistorico.dataFinal">
                                        </div>
                                    </div>                                                                                                                              
                                    <div class="col-lg-1 col-xs-2">
                                        <div class="submit-field" >
                                            <div class="hidden-xs clearfix" style="margin-top: 32px;"></div>
                                            <button class="button gray " v-on:click="formHistorico.page = 1;">
                                                <i class="material-icons">search</i>
                                            </button>                                          
                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form> 


                            <div class="table-scroll margin-top-5" style="overflow-x: scroll;">
                      
                                <table class="table table-bordered table-bordered-default table-responsive margin-bottom-20">
                                    <thead>
                                        <th style="min-width: 10px; width: 30px;">
                                            ID
                                        </th>
                                        <th style="min-width: 250px;">
                                            Estoque
                                        </th>
                                        <th style="min-width: 80px; width: 80px;">
                                            Produto
                                        </th>    
                                        <th style="min-width: 170px; width: 170px;">
                                            Movimentação
                                        </th>                                            
                                        <th style="min-width: 100px; width: 100px;">
                                            Quantidade
                                        </th>
                                        <th style="min-width: 140px; width: 140px;">
                                            Data/hora
                                        </th>                                                                      
                                    </thead>
                                    <tbody>

                                        <tr v-show="historico.itens.length == 0 && loaded">
                                            <td data-label="" colspan="7">
                                                Nenhum resultado encontrado.
                                            </td>                                                                                           
                                        </tr>
                                       
                                        <tr v-for="(item, index) in historico.itens">
                                            <td data-label="ID">
                                                {{item.id}}                                  
                                            </td>
                                            <td data-label="Estoque" style="">
                                                {{item.estoque.nome}}

                                                <br v-if="item.medicao && item.medicao > 0">
                                                <small v-if="item.medicao && item.medicao > 0">
                                                    <i class="material-icons">info</i> Medição do tanque:    <strong style="font-weight: bold !important; color: #000;">{{item.medicao}}</strong>
                                                </small> 

                                                <br v-if="item.observacao">
                                                <small v-if="item.observacao">
                                                    <i class="material-icons">info</i> Observações:    <strong style="font-weight: bold !important; color: #000;">{{item.observacao}}</strong>
                                                </small>

                                                <br v-if="item.cliente">
                                                <small v-if="item.cliente">
                                                    <i class="material-icons">people</i> Cliente:    <strong style="font-weight: bold !important; color: #000;">{{item.cliente.razaoSocial ? item.cliente.razaoSocial : item.cliente.nome}}</strong>
                                                </small>

                                                <br v-if="item.destinoEstoqueCod">
                                                <small v-if="item.destinoEstoqueCod">
                                                    <i class="material-icons">redo</i> Estoque de destino:    <strong style="font-weight: bold !important; color: #000;">{{item.estoqueDestino.nome}} -{{item.estoqueDestino.empresa.nome}} </strong>
                                                </small>            

                                                <br v-if="item.empresa">
                                                <small v-if="item.empresa">
                                                    <i class="material-icons">store</i> Filial:    <strong style="font-weight: bold !important; color: #000;">{{item.empresa.nome}}</strong>
                                                </small>    

                                                <br v-if="item.usuario">
                                                <small v-if="item.usuario">
                                                    <i class="material-icons">account_circle</i> Usuário:    <strong style="font-weight: bold !important; color: #000;">{{item.usuario.nome}}</strong>
                                                </small>

                                            </td>     
                                            <td data-label="Produto" style="">
                                                {{item.catalogo.nome}}
                                            </td>                                           
                                            <td data-label="Movimentação" style="">
                                                <small v-if="item.tipo == 'agendamento'">
                                                    <i class="material-icons" style="margin-right: 2px;">local_gas_station</i>Abastecimento
                                                </small>
                                                <small v-if="item.tipo == 'abastecimento'">
                                                    <i class="material-icons" style="margin-right: 2px;">local_gas_station</i>Abastecimento
                                                </small>
                                                <small v-if="item.tipo == 'venda'">
                                                    <i class="material-icons" style="margin-right: 2px;">shopping_cart</i>Venda - granel
                                                </small>
                                                <small v-if="item.tipo == 'movimentacao'">
                                                    <i class="material-icons" style="margin-right: 2px;" v-if="item.tipo == 'movimentacao'">redo</i>Movimentação manual
                                                </small>
                                                <div style="display: block; height: 5px;"></div>
                                                <span class="dashboard-status-button gray" style="">
                                                    {{item.movimentacao == 'saida' ? 'Saída' : ''}}
                                                    {{item.movimentacao == 'entrada' ? 'Entrada' : ''}}
                                                    {{item.movimentacao == 'transferencia' ? 'Transferência' : ''}}
                                                    {{item.movimentacao == 'transferencia-filial' && item.destinoEstoqueCod ? 'Saída - Transferência entre filiais' : ''}}
                                                    {{item.movimentacao == 'transferencia-filial' && !item.destinoEstoqueCod ? 'Entrada - Transferência entre filiais' : ''}}
                                                    {{item.movimentacao == 'medicao' ? 'Medição do tanque' : ''}}
                                                    {{item.movimentacao == 'cancelamento' ? 'Cancelamento' : ''}}
                                                </span>
                                                <br v-if="item.arquivo">
                                                <i v-if="item.arquivo" class="material-icons" style="margin-right: 1px !important; top: 2px !important;">photo</i>
                                                <a style="font-size: 12px; text-decoration: underline;" v-if="item.arquivo" :href="item.arquivo" target="_blank">
                                                    Visualizar foto
                                                </a>
                                            </td>                                                     
                                            <td data-label="Quantidade">
                                                {{parseFloat(item.quantidadeDepois).toLocaleString("pt-br", {minimumFractionDigits: 1})}}L
                                            </td>
                                            <td data-label="Data/hora" style="">
                                                {{item.datahora |formatDate}}
                                            </td>                                                                                             
                                        </tr>
                                                                             
                                    </tbody>
                                </table>
                            </div>
                            <div class="pagination-container margin-top-60 margin-bottom-60">
                                <nav class="pagination">
                                    <ul>
                                        <li class="pagination-arrow" v-show="historico.page > 1" v-on:click="formHistorico.page = (historico.page - 1); getHistorico(true);">
                                            <a>
                                                <i class="material-icons">arrow_back</i>
                                                Anterior
                                            </a>
                                        </li>
                                        <li class="pagination-arrow" v-show="historico.page >= 1 && historico.page < (historico.pages.length)" v-on:click="formHistorico.page = (historico.page + 1); getHistorico(true);">
                                            <a>
                                                Próxima
                                                <i class="material-icons">arrow_forward</i>
                                            </a>
                                        </li>    
                                        <br class="hidden-lg hidden-xl hidden-md">                                        
                                        <li v-for="(item, index) in historico.pages" v-show="item.show">
                                            <a class="" v-bind:class="{'current-page': item.index == historico.page}" v-on:click="formHistorico.page = item.index; getHistorico(true);">
                                                {{item.index}}
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>                            
                        </div>                        
                    </div>

                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Estoque',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];
            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 1})                
            } else {
                return "0,00";
            }         
        },        
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "tab":                  "lista",
            "visualizar": {
                "itens":            []
            },
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "historico": {
                "itens":            []
            },
            "clientes": {
                "itens":            []
            },
            "empresas": {
                "itens":            []
            },
            "catalogo": {
                "itens":            []
            },            
            "formHistorico": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "historico",                
                "dataInicio":       "",
                "dataFinal":        "",
                "page":             1
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "empresaCod":       "",
                "mes":              (new Date().getMonth()+1),
                "ano":              (new Date().getFullYear()),
                "itens":            []
            },
        }
    },
    watch: {           
    },
    methods: {
        setTab: function(tab) {
            var self        = this;
            console.log("setTab()", tab);
            self.tab        = tab;

            if (tab == "editar" || tab == "visualizar" || tab == "lista") {
                self.get();
            }

            if (tab == "historico") {
                self.getHistorico();
            }            

        },   
        loadTanques: function() {
            var self    = this;
            console.log("loadTanques()", self.data);
            setTimeout(function() {
                Object.keys(self.data.itens).forEach(function(item, index) {
                    (self.data.itens[item]).forEach(function(item2) {
                        var porcentagem         = item2.porcentagem;
                        var fm                  = new FluidMeter();
                        fm.init({
                            targetContainer:    $(".tanque-conteudo-" + item2.cod)[0],
                            fillPercentage:     porcentagem,
                            options: {
                                fontSize: "50px",
                                fontFamily: "Arial",
                                fontFillStyle: "white",
                                drawShadow: true,
                                drawText: true,
                                drawPercentageSign: true,
                                drawBubbles: false,
                                size: 250,
                                borderWidth: 4,
                                backgroundColor: "#eeeeee",
                                foregroundColor: "#dddddd",
                                foregroundFluidLayer: {
                                    fillStyle: "transparent",
                                    angularSpeed: 1,
                                    maxAmplitude: 0,
                                    frequency: 0,
                                    horizontalSpeed: 1
                                },
                                backgroundFluidLayer: {
                                    fillStyle: item2.catalogo.cor,
                                    angularSpeed: 1,
                                    maxAmplitude: 0,
                                    frequency: 0,
                                    horizontalSpeed: 1
                                }                            
                            }                            
                        });             
                    });
                });
            }, 100);

        }, 
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/estoque-v2.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get().then(function() {
                        loading.hide();
                    }).catch(function() {
                        loading.hide();
                    });
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },    
        getEmpresas: function() {
            var self        = this;
            console.log("getEmpresas()");
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "empresas",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/empresas.php", form)
                .then(response => {
                    
                    console.log("getEmpresas() response", response);
                    self.empresas       = response.data.result;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getEmpresas() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },  
        getHistorico: function() {
            var self        = this;
            console.log("getHistorico()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "estoqueHistorico",
                    "params":           self.formHistorico
                };

                axios.get("api/estoque-v2.php", form)
                .then(response => {
                    
                    console.log("getHistorico() response", response);
                    self.historico       = response.data.result;
                    loading.hide();
                    self.$root.scrollTop();

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getHistorico() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },                        
        get: function() {
            var self        = this;
            console.log("get()", self.data);
            self.data.itens = [];
            self.loaded     = false;
            loading.show();
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo == "prestador") {
                    self.form.empresaCod = self.$root.user.empresaCod;
                }

                var form = {
                    "db":               "estoque",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "empresaCod":   self.form.empresaCod
                    }
                };

                axios.get("api/estoque-v2.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data.itens     = response.data.result.itens; 
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
                    if (self.tab == "visualizar") self.loadTanques();
                    self.$root.scrollTop();
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },
        init: function() {
            var self = this;
            // if (self.tab == "historico") {
            //     self.getHistorico();    
            // }

            self.$root.tmp.estoque.tab = "";

            Promise.all([
                self.get(),
                self.getEmpresas(),
                self.getHistorico()
            ]).then(function() {
            
                loading.hide();
                // if (self.tab != "historico") self.getHistorico();
                
            }).catch(function(error) {
                loading.hide();
            });             
        }
    },
    created: function() {
        var self = this;
        loading.show();        

        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.init();
            });
        } else {
            self.init();
        }      

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table td button i {
        font-size: 20px !important;
        color: #fff;
    }
    .table td button {
        margin-top: 0px !important;
    }
    .table td {
        /*border-right: none;*/
        /*border-left: none;*/
    }
    .table td input, .table td select {
        margin-top: 0px;
        margin-bottom: 0px;
        text-align: left
    }
    .tab-visualizar h3 {
        color: #666;
    }
    .tanque {
        border: 1px solid #ddd;
        text-align: center;
        padding: 2%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #fff;
    }
    .tanque h1 {
        position: absolute;
        /*display: block;*/
        /*margin: 0 auto;*/
        text-align: center;
    }
    .tanque h4 {
        text-align: center;
        font-size: 1.1em;
        margin-bottom: 15px;
    }
    .tanque-nivel {
        width: 100%;
        background: #ddd;
        height: 10%;
        position: relative;
        bottom: 0px;
        z-index: -1;
    }
    .tanque p {
        margin-bottom: 0px;
    }
    .tanque p b {
        color: #333;
    }

    .tanque-area {
        display: flex;
        align-items: flex-end;
        align-content: center;
        border-bottom-right-radius: 100%;
        border-bottom-left-radius: 100%;
        /*text-align: center;*/
        width: 10em;
        height: 10em;
        border-radius: 50%;
        border: 2px solid #666;
    }

    .dashboard-status-button.color-green {
        /*display: block; */
        /*background: #F89012 !important;*/
        margin-top: 5px; 
        color: #fff !important;
        width: auto; 
        padding: 2px 8px;
        text-align: center;
    }

    .dashboard-status-button.color-green i {
        font-size: 16px;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/Estoque.vue